import getItemPosition from './getItemPosition';

/**
 * Calculates the overall position of an item across all paginated search results.
 * Used for analytics tracking to understand where users interact with items.
 *
 * @param itemId - The ID of the item to find the position for
 * @param page - Current page number (1-based)
 * @param pageSize - Number of items per page
 * @param searchPageItemIds - Array of item IDs on the current page
 * @returns The 1-based position of the item across all search results, or 0 if pagination data is unavailable
 *
 * @example
 * // Page 3, pageSize 20, item at index 2 on current page
 * // Result: (3-1) * 20 + (2+1) = 43 (item is 43rd overall)
 */
export const getPagePosition = (
    itemId: number,
    page: number,
    pageSize: number,
    searchPageItemIds: number[]
): number => {
    // Early return if pagination data is not available
    if (!Boolean(page) || !Boolean(pageSize)) {
        return 0;
    }

    // Find the 0-based index of this item within the current page's results
    const itemIndexOnCurrentPage = searchPageItemIds.indexOf(itemId);

    // Calculate the overall position of the item across all search results
    const overallSearchPosition = getItemPosition(page, pageSize, itemIndexOnCurrentPage);

    return overallSearchPosition;
};
